import React, {Component, useRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import _ from 'lodash';

import MenuList from '../../components/MenuList';
import logo from '../../assets/images/logo.png';
// import feature from '../../assets/images/cbeatsheader.png';
import feature from '../../assets/images/click2order-background.png';
import delivery from '../../assets/images/delivery.svg';
import pickup from '../../assets/images/pickup.svg';
import clock from '../../assets/images/clock-icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import LoadingSpinner from '../common/LoadingSpinner';
import { setCartPanel } from '../../actions/panels';
import { validateLogin } from '../../actions/auth';
import { loadCart, cartInfoUpdate } from '../../actions/cart';
import ViewFoodItemModal from '../fooditems/ViewFoodItemModal';
import ViewPizzaModal from '../pizzas/ViewPizzaModal';
import ViewCustomPizzaModal from '../custompizzas/ViewCustomPizzaModal';
import ViewSpecialModal from '../specials/ViewSpecialModal';

import Tabs from '../common/NavigationTabs';

// actions
import { getCurrentLocation, currentLocationLoading, loadCurrentLocation } from '../../actions/currentLocation';

// images
// import locationHeaderImage from '../../assets/img/feature_image_default.jpg';
// import locationDefaultLogo from '../../assets/img/logo.png';

// constants and utilities
import { API_URL, WLID, COLOR_PRIM, FONT_PRIM, FONT_PRIM_BOLD, FONT_SEC_BOLD, FONT_ANDROID_BOLD, FONT_ANDROID_NORMAL, FONT_ANDROID_MEDIUM, FONT_POPPINS_REGULAR, FONT_POPPINS_BOLD, FONT_POPPINS_EXTRA_BOLD, FONT_POPPINS_LIGHT } from '../../config/constants';
import { useLocation } from 'react-router-dom';
// import { dayNames, getFormattedTime } from '../../utils/dateUtil';


class RestaurantIndexPage extends Component {

    constructor(props) {
        super(props);

        this.setMainMenuLink = this.setMainMenuLink.bind(this);
        this.setAnchor = this.setAnchor.bind(this);
        this.goToAnchor = this.goToAnchor.bind(this);


        this.anchorPoints = new Map();
        this.state = {
            hoursExpanded: false
        }

        
    }

    componentDidMount() {

        if (!this.props.currentLocation.location) {
            this.props.dispatch(currentLocationLoading());
            this.props.dispatch(getCurrentLocation(this.props.match.params.lid, false, {}, {}, true));
        }

        const token = window.localStorage.getItem('c2o.token');
        if (token) {
            this.props.dispatch(validateLogin({ token }));
        }

        // determine if there is a cart that needs to be updated
        if (!this.props.cart.cart_loaded) {
            const storedCartJson = window.localStorage.getItem('c2o.cart.'+this.props.match.params.lid);

            if (storedCartJson) {
                const now = new Date();
                const storedCartInfo = JSON.parse(storedCartJson);
                const expiry = storedCartInfo.expiry;
                const cart = storedCartInfo.cart;

                // check the expiry date
                if (now.getTime() < expiry) {
                    this.props.dispatch(loadCart(cart));
                } else {
                    window.localStorage.removeItem('c2o.cart.'+this.props.match.params.lid);
                }
            }
        }

        this.props.dispatch(cartInfoUpdate({prop: 'cart_loaded', value: true}));
    }

    componentDidUpdate() {

        // determine if there is a cart that needs to be updated
        const storedCartJson = window.localStorage.getItem('c2o.cart.'+this.props.match.params.lid);
        const storedCartInfo = JSON.parse(storedCartJson);
        let storedCart = {};
        if (storedCartInfo && storedCartInfo.cart) {
            storedCart = storedCartInfo.cart;
        }
        
        // make sure that the cart is loaded so that we're not accidentally overwriting anything
        if (this.props.cart.cart_loaded) {
            let cartJson = JSON.stringify(this.props.cart);
            let cart = JSON.parse(cartJson);
            delete cart.cart_loaded; 

            if (!_.isEqual(storedCart, cart)) {
                const now = new Date();
                const storageCart = {
                    cart,
                    expiry: now.getTime() + (0.25*60*1000)
                };
                
                window.localStorage.setItem('c2o.cart.'+this.props.match.params.lid, JSON.stringify(storageCart));
            }
        }
    }

    getTotalCartItems() {

        // get the total cart items
        let totalItems = 0;

        // pizzas
        for (let i = 0; i < this.props.cart.items.pizzas.length; i++) {
            totalItems += this.props.cart.items.pizzas[i].quantity
        }
        
        // food items
        for (let i = 0; i < this.props.cart.items.fooditems.length; i++) {
            totalItems += this.props.cart.items.fooditems[i].quantity
        }

        // beverages
        for (let i = 0; i < this.props.cart.items.beverages.length; i++) {
            totalItems += this.props.cart.items.beverages[i].quantity
        }

        // specials
        for (let i = 0; i < this.props.cart.items.specials.length; i++) {
            totalItems += this.props.cart.items.specials[i].quantity
        }

        // addons
        for (let i = 0; i < this.props.cart.items.addons.length; i++) {
            totalItems += this.props.cart.items.addons[i].quantity
        }

        return totalItems;
    }

    setAnchor(ref) {
        return this.sectionList = ref;
    }

    goToAnchor(idx) {
        this.sectionList.scrollToLocation({
            sectionIndex: idx,
            itemIndex: 0,
            viewPosition: 0
        });
    }

    createStaticCategoryList() {

        let categoryList = [];

        // @TODO: we don't really need these variables, and we can always factor them out
        if (this.props.currentLocation.hasSpecials) {
            categoryList.push({
                name: 'Specials',
                linkToSpecials: true
            });
        } 

        if (this.props.currentLocation.hasPizzas) {
            categoryList.push({
                name: 'Pizzas',
                linkToPizzas: true
            });
        } 

        return categoryList;
    }

    setMainMenuLink(item) {

        if (item.linkToSpecials) {
            this.props.navigation.navigate('SpecialsMenu');
        }
        else if (item.linkToPizzas) {
            this.props.navigation.navigate('PizzasMenu');
        }
        else if (item.linkToBeverages) {
            this.props.navigation.navigate('BeveragesMenu');
        }
        else {
            this.props.navigation.navigate('FoodItemsMenu', {
                cid: item.id
            });
        }
    }

    renderLocationHeaderImage() {

        let featureImage = "";
        let logoImage = "";

        if ( this.props.currentLocation && this.props.currentLocation.location.feature && this.props.currentLocation.location.feature != "" ) {
            featureImage = API_URL +  "/" + this.props.currentLocation.location.feature
        }

        if ( this.props.currentLocation.location.logo && this.props.currentLocation.location.logo != "" ) {
            logoImage = API_URL + "/" + this.props.currentLocation.location.logo;
            
        }   

        return (
            <div>
                <div >
                    <img src={ featureImage  ? featureImage : feature } className="headerImage" />
                </div>
                <div className="logoCircle" >
                    <img src={logoImage ? logoImage : logo } className="logoCircle" />     
                </div>
            </div>
        );
    }

    renderLocationInformation() {
        return (
            <div className="sectionHeaderSection">
            {this.renderLocationHeaderImage()}
            <div className="restaurantInfoWrapper">            
                <h2 className="headingInRestaurant">{this.props.currentLocation.name}</h2>
                <div className="addressWrapper">
                    <div className="textBlock3">{this.props.currentLocation.location.address}</div>
                    <div className="textBlock3">,</div>
                    <div className="textBlock3">{ this.props.currentLocation.location.city }</div>
                </div>
                <div className="optionswrapperInRestaurant">
                    {((this.props.currentLocation.location.pickup_options == "BOTH" || this.props.currentLocation.location.pickup_options == "DELIVERY ONLY")) && (
                        <div className="individualOptionWrapper">
                            <img src={delivery}  className="deliveryIcon" />
                            <div className="pickupOptions">Delivery</div>
                        </div>
                    )}
                    {(this.props.currentLocation.location.pickup_options == "BOTH" || this.props.currentLocation.location.pickup_options == "PICKUP ONLY") && (
                      <div className="individualOptionWrapper">
                        <img src={pickup}  className="deliveryIcon" />
                        <div className="pickupOptions">Pick Up</div>
                      </div>
                    )}
                    
                </div>

                {( this.props.currentLocation.location.open == "1" ? (
                    <div className="optionswrapperInRestaurantHours">
                        <div className="individualOptionWrapper">
                            <img src={clock}  className="deliveryIcon" />
                            <div className="pickupOptions">Open Today {this.props.currentLocation.location.opensAt} - {this.props.currentLocation.location.openTime}</div>
                        </div>
                        {this.props.currentLocation.location.pickup_options != "PICKUP ONLY" && this.props.currentLocation.location.dispatch_open == 1 && this.props.currentLocation.location.delivery_closed == 0 && (this.props.currentLocation.location.opensAt != this.props.currentLocation.location.deliveryOpensAt || this.props.currentLocation.location.openTime != this.props.currentLocation.location.deliveryOpenTime) && (
                            <div className="individualOptionWrapper" style={{marginTop: 10}}>
                                <img src={delivery}  className="deliveryIcon" />
                                <div className="pickupOptions">Delivering from {this.props.currentLocation.location.deliveryOpensAt} - {this.props.currentLocation.location.deliveryOpenTime}</div>
                            </div>
                        )}
                        {this.props.currentLocation.location.pickup_options != "PICKUP ONLY" && (this.props.currentLocation.location.dispatch_open == 0 || this.props.currentLocation.location.delivery_closed == 1) && (this.props.currentLocation.location.opensAt != this.props.currentLocation.location.deliveryOpensAt || this.props.currentLocation.location.openTime != this.props.currentLocation.location.deliveryOpenTime) && (
                            <div className="individualOptionWrapper" style={{marginTop: 10}}>
                                <img src={delivery}  className="deliveryIcon" />
                                <div className="pickupOptions">Delivery is Currently Closed</div>
                            </div>
                        )}
                    </div>
                ): (
                    <div className="closedWrapper">
                        <div className="textBlock4">Online Ordering Closed</div>
                        <div className="finePrint">Please come back when we're open!</div>
                    </div>
                ))}
            </div>
        </div>
        );
    }

    renderCategoryNavigator(categoryList) {
        return categoryList.map((category) =>(
            <ScrollLink to={category.name.replace(/\s+/g, '')} spy={true} smooth={true} offset={-65} >{category.name}</ScrollLink>
        ))
    }

    render() {
        const mainList = this.createStaticCategoryList();
        let fullList = [];
 
        if (this.props.currentLocation.categories) {
            fullList = mainList.concat(this.props.currentLocation.categories); 
        }
        if (this.props.loading) {
            return (
                <LoadingSpinner />
            );
        }
        else {
            return (     
                <div className="body">
                    <div className="breakpointContainer">
                       
                       <div className="scrollmenu">
                            {this.renderCategoryNavigator(fullList)}
                        </div>
                       
                        {this.renderLocationInformation()}
                        <div className="sectionRestaurantPage">
                      
                            {(fullList.length > 0) && (
                                   <MenuList
                                    data={fullList}
                                   />        
                            )}

                            {(fullList.length == 0) && (
                                <p>No items available</p>
                            )}
                        
                        </div>  
                        
                        <Link 
                            className="cart-wrapper hide"
                            to={'/'+this.props.match.params.sitename+'/'+this.props.match.params.lid+"/cart"}
                        >
                            <div onClick={() => this.props.dispatch(setCartPanel())} className="cart-button-restaurant-index-page">
                                <FontAwesomeIcon icon={faShoppingCart} />
                                <div className="cart-number">
                                   {this.getTotalCartItems()}</div>
                            </div>     
                        </Link>
                    </div>

                    <ViewFoodItemModal 
                        history={this.props.history}
                        locationId={this.props.match.params.lid}
                        sitename={this.props.match.params.sitename}
                    />

                    <ViewPizzaModal 
                        history={this.props.history}
                        locationId={this.props.match.params.lid}
                        sitename={this.props.match.params.sitename}
                    />

                    <ViewSpecialModal
                        history={this.props.history}
                        locationId={this.props.match.params.lid}
                        sitename={this.props.match.params.sitename}
                     />

                    <ViewCustomPizzaModal
                        history={this.props.history}
                        locationId={this.props.match.params.lid}  
                        sitename={this.props.match.params.sitename}
                    />
                    
                    <Tabs 
                        lid={this.props.match.params.lid}
                        sitename={this.props.match.params.sitename}
                        section="eats"
                    />
                </div>     
            );
        }
    }
}

const mapStateToProps = (state) => {

    return {
        fuck: state.currentLocation,
        isOpen: state.currentLocation.open,
        loading: state.currentLocation.loading,
        currentLocation: state.currentLocation.info,
        cart: state.cart
    };
};

export default connect(mapStateToProps)(RestaurantIndexPage);
